// @ts-nocheck
/* eslint-disable */
import { createRouteReport } from "~/report/route";
import { CONFIG, Scene, _, Notifications } from "~/route/globals";
import RouteSummary from "./summary/main";
import { createAlternatives } from "~/route/alternatives";
import { ROUTE_CONST } from "~/route/const";
import { NOTIFICATIONS_TYPE } from "~/util/notifications";
import { store } from "~/state/store";
import { watch, watchUser } from "~/state/util";
import { icon, node } from "~/util/dom";

/**
 * Obal pro:
 * - vybrana trasa k zobrazeni, prepinatko alternativnich tras
 */
export default class Routes {
	constructor() {
		this._container = node("div", { className: "route-summary" });
		this._adContainer = node("div", { className: "ad-container-route noprint" });
		this._adPlaceholder = node("div");
		this._arrow = icon("arrow");
		this._scrollEl = document.getElementById("layout-scroll");
		this._lids = [];
		this._summarys = [];
		this._actualIndex = 0;
		this._disabled = false;

		this._setListeners();
	}

	destroy() {
		this._container.remove();
		this._setAd(Mapy.CML.state);
		Mapy.CML.removeListeners(this._lids);
	}

	get container() {
		return this._container;
	}

	set showAlternatives(show) {
		let routeState = Mapy.CML.state.route;

		this._container.classList.add("anim");

		if (!show) {
			this._summarys.forEach((s, i) => {
				if (i != routeState.index) {
					s.button.classList.add("hide");
				}
				else {
					s.button.classList.add("alt-0");
				}
			});

			setTimeout(() => {
				this._summarys.forEach((s, i) => {
					if (i != routeState.index) {
						s.button.remove();
					}
				});
			}, 450);

			this._container.classList.add("alt-1");
			this._container.classList.add("i-0");
		}
		else {
			const frag = Mapy.Util.fragment();

			this._summarys.forEach((s, i) => {
				frag.appendChild(s.button);
			});

			this._container.insertBefore(frag, this._container.firstChild);

			requestAnimationFrame(() => {
				this._summarys.forEach((s, i) => {
					if (i != routeState.index) {
						requestAnimationFrame(() => {
							s.button.classList.remove("hide");
						});
					}
					else if (0 != routeState.index) {
						requestAnimationFrame(() => {
							s.button.classList.remove("alt-0");
						});
					}
				});
			});

			let altNum = routeState.responseData.length;
			if (altNum != 1) {
				this._container.classList.remove("alt-1");
				this._container.classList.remove("i-0");
				requestAnimationFrame(() => {
					this._container.classList.add(`alt-${altNum}`);
					this._container.classList.add(`i-${routeState.index}`);
				});
			}
		}

		setTimeout(() => {
			this._container.classList.remove("anim");
		}, 300);
	}

	set disabled(disabled) {
		this._disabled = disabled;
	}

	show() {
		this._summarys.forEach(s => {
			s.show();
		});
	}

	hide() {
		this._summarys.forEach(s => {
			s.hide();
		});
	}

	/**
	 * Nastaveni posluchacu.
	 */
	_setListeners() {
		let rebuildSummary = state => {
			Mapy.Util.clear(this._container);

			while (this._summarys.length) {
				let summary = this._summarys.pop();
				summary.destroy();
			}

			this._actualIndex = 0;
			this._summarys = [];

			if (!this._disabled) {
				state.route.responseData.forEach((data, ind) => {
					this._summarys[ind] = new RouteSummary(data, state.route, ind);
				});

				this._showSummary(state.route.index, state.route.scroll, state.route.items);
			}

		}

		this._lids.push(Mapy.CML.addListener((responseData, state) => {
			rebuildSummary(state);
		}, "route.likeDataChange"));

		if (Mapy.CUS.route.datetimeForAll) {
			this._lids.push(Mapy.CML.addListener((trafficTotalTime, state) => {
				trafficTotalTime.forEach((time, index) => this._summarys[index].setTime(time));
			}, "route.trafficTotalTime"));
		}

		this._lids.push(Mapy.CML.addListener((items, state) => {
			rebuildSummary(state);
		}, "route.items"));

		this._lids.push(Mapy.CML.addListener((request, state) => {
			rebuildSummary(state);
			if (!request && this._summarys[0] && state.route.items.length && !state.route.items[0].planTrip) {
				this._summarys[0].scrollToViewport();
			}

			if (!request && this._summarys[0]) {
				this._setAd(state);
			}
		}, "route.request"));

		this._lids.push(Mapy.CML.addListener((error, state) => {
			if (error != "") {
				let status = state.route.status;

				if (status === 404) {
					createRouteReport(state);
				} else {
					let msg = _("route3.error.default");

					switch (status) {
						case 406: msg = _("route3.error.406"); break;
						case 408: msg = _("route3.error.408"); break;
						case 409: msg = _("route3.error.409"); break;
						case 410: msg = _("route3.error.410"); break;

						default:
							if (status >= 500 && status < 600) {
								msg = _("route3.error.500");
							}
					}

					Notifications.notify({
						content: msg,
						type: status === 410 ? NOTIFICATIONS_TYPE.SUCCESS : NOTIFICATIONS_TYPE.ERROR,
					});
				}

				Mapy.Util.clear(this._container);
			}
		}, "route.error"));

		this._lids.push(Mapy.CML.addListener((index, state) => {
			if (state.route.alternatives) {
				if (!this._summarys.length) { return; }

				this._summarys[index].reload();

				this._summarys.forEach((s, i) => {
					if (i == index) {
						if (ROUTE_CONST.types.pubt.criterion.indexOf(state.route.params.criterion) !== -1 || state.route.params.datetime) {
							this._container.prepend(s.departureInfo);
						}
						this._container.appendChild(s.box);
						s.button.classList.remove("hover");
						s.button.classList.add("active");
					}
					else {
						s.departureInfo.remove();
						s.box.remove()
						s.button.classList.remove("active");
						s.hide();
					}
				});

				if (state.route.responseData.length) {
					this._container.appendChild(this._arrow);
				}

				requestAnimationFrame(() => {
					this._container.classList.remove(`i-0`);
					this._container.classList.remove(`i-1`);
					this._container.classList.remove(`i-2`);
					this._container.classList.add(`i-${state.route.selectedAlternative ? 0 : index}`);
				});

				if (state.route.likeData) {
					let response = state.route.responseData[index];
					let likedata = state.route.likeData;
					let change = response.routeWaypoints && likedata.data && likedata.data.routeParams.routeWaypoints && response.routeWaypoints == likedata.data.routeParams.routeWaypoints;
					Mapy.CML.state = {
						route: {
							likeDataChange: !change
						}
					}

					if (change) {
						Mapy.getComponent("dimcurator").setState({ dim: state.route.likeData.id });
					}
				}
			}
		}, "route.index"));

		this._lids.push(Mapy.CML.addListener((index, state) => {
			this._hoverSummary(index, state);
		}, "route.hoverIndex"));
	}

	_hoverSummary(index, state) {
		requestAnimationFrame(() => {
			this._summarys.forEach((s, i) => {
				if (i != state.route.index) {
					s.button.classList[i == index ? "add" : "remove"]("hover");
				}
			});
		});
	}

	_showSummary(index, scroll, items) {
		if (this._summarys[index]) {
			const routeState = Mapy.CML.state.route;

			Mapy.Util.clear(this._container);

			this._container.classList.remove("alt-1");
			this._container.classList.remove("alt-2");
			this._container.classList.remove("alt-3");
			this._container.classList.remove("i-1");
			this._container.classList.remove("i-2");
			this._container.classList.remove("i-3");
			this._container.classList.add(`alt-${routeState.responseData.length}`);
			this._container.classList.add(`i-${routeState.selectedAlternative ? 0 : index}`);

			if (ROUTE_CONST.types.pubt.criterion.indexOf(routeState.params.criterion) !== -1 || routeState.params.datetime) {
				this._container.appendChild(this._summarys[index].departureInfo);
			}

			this._summarys.forEach((s, i) => {
				this._container.appendChild(s.button);
			});

			this._container.appendChild(createAlternatives());
			this._container.appendChild(this._summarys[index].box);
			this._container.appendChild(this._arrow);

			requestAnimationFrame(() => {
				this._summarys.forEach((s, i) => {
					if (i == index) {
						s.button.classList.remove("hover");
						s.button.classList.add("active");
					}
					else {
						s.button.classList.remove("active");
					}
				});
			});

			let isTrip = items.length && items[0].tripData.length;

			// skrolovani na konec - pouze pokud je boolean, pokud to je cislo, chova se to jinak
			if (scroll && typeof scroll === "boolean" && !isTrip) {
				this._summarys[index].scrollToViewport();
			}

			this._summarys[index].setAd(this._adContainer);

			this._actualIndex = index;
		}
	}

	_setAd(s) {
		let state = s.route;

		if (state.items.length > 1 && state.responseData.length && "sssp" in window && !Mapy.getComponent("print").mode
			&& state.params.type != ROUTE_CONST.TYPE_PUBT && state.params.type != ROUTE_CONST.TYPE_BOAT) {
			let lengthString = "";
			let length = state.responseData[0].totalLength;

			switch (true) {
				case (length >= 0 && length <= 30000): lengthString = "0-30Km"; break;
				case (length >= 30001 && length <= 60000): lengthString = "30-60Km"; break;
				case (length >= 60001 && length <= 120000): lengthString = "60-120Km"; break;
				case (length >= 120001 && length <= 180000): lengthString = "120-180Km"; break;
				case (length >= 180001 && length <= 250000): lengthString = "180-250Km"; break;
				case (length >= 250001 && length <= 600000): lengthString = "250-600Km"; break;
				case (length >= 600001): lengthString = "601Km+"; break;
			}

			let type = "auto";
			let typeShort = "c";
			switch (state.params.criterion) {
				// kolo
				case 121:
				case 122:
					type = "kolo";
					typeShort = "b";
					break;

				// pesky
				case 131:
				case 132:
					type = "pesi";
					typeShort = "f";
					break;

				// lyze
				case 141:
					type ="lyzar";
					typeShort = "s";
					break;
			}

			let commerceEnd = state.items[state.items.length - 1].commerce;

			let commerceTypes = function(commerceEnd) {
				if (commerceEnd && "areaTypes" in commerceEnd) {
					for (let i = 0; i < commerceEnd.areaTypes.length; i++) {
						commerceEnd.areaTypes[i] = commerceEnd.areaTypes[i].replace(" ", "_");
					}

					return " " + Mapy.Util.removeDiacritic(commerceEnd.areaTypes.join(" "));
				}
				else {
					return "";
				}
			};

			if (["cs", "sk"].indexOf(CONFIG.defaultLang) > -1) {
				const wtUser = watch(store.getState, "user", watchUser);
				const callAdv = () => {
					this._adContainer.innerHTML = "";
					this._adPlaceholder.innerHTML = "";
					this._adContainer.appendChild(this._adPlaceholder);

					if ("sssp" in window) {
						sssp.getAds({
							id: this._adPlaceholder,
							zoneId: 117969,
							width: 300, // max sirka pro reklamu, mame pravy panel, muze byt i scroll, vysku neresime
							height: 250,
							options: {
								collocation: type + " " + lengthString + (commerceEnd && "country" in commerceEnd ? " " + Mapy.Util.removeDiacritic(commerceEnd.country.replace(" ", "_")) : "") + commerceTypes(commerceEnd),
								infoCallback: ad => {
									if (ad.type != "empty") {
										requestAnimationFrame(() => {
											this._adContainer.appendChild(node("span", {}, _("advertising")));
											this._adContainer.classList.add("show");
										});
									}
									else {
										this._adContainer.remove();
									}
								},
								passons: {
									length,
									points: [Scene.stringToCoords(state.items[0].geometry)[0].toWGS84().join(" "), Scene.stringToCoords(state.items[state.items.length - 1].geometry)[0].toWGS84().join(" ")].join(","),
									type: typeShort,
								}
							}
						});
					}
				};

				this._storeUnsubscribe = store.subscribe(wtUser(() => {
					// musime znova zavolat o reklamu, pac muze byt placeny bez reklam
					this._adPlaceholder.remove();
					this._summarys[this._actualIndex]?.setAd(this._adContainer);
					callAdv();
				}));

				callAdv();
			}
		}
		else {
			this._adContainer.remove();
		}
	}
}
